export enum PolicyTermType {
	PrivacyPolicy = "PrivacyPolicy",
	PhotoPrivacyPolicy = "PhotoPrivacyPolicy",
	TermsAndConditions = "TermsAndConditions",
	PhotoTerms = "PhotoTerms",
	TermsOfUse = "WebSiteTerms",
	CookiePolicy = "CookiePolicy",
	KioskPlayNow = "KioskPlayNow",
}
export interface IPolicyTerm {
	IsEnabled: boolean,
	UrlLabel?: string,
	Title?: string,
	Content?: string
}
export interface IPolicyTermMenu {
	IsEnabled: boolean;
	UrlLabel: string;
	Type: PolicyTermType;
}

interface IPhotoPolicySection {
	Label: string;
	Title: string;
	Description: string;
}

export interface IPhotoPrivacyAndTerms {
	IsActive: boolean;
	MinAge: number;
	PrivacyPolicy: IPhotoPolicySection;
	TermsOfService: IPhotoPolicySection;
}

export type RestResponse<RC extends (...args: any) => any, FN extends keyof ReturnType<RC>> = Exclude<Awaited<ReturnType<ReturnType<RC>[FN]>>["data"], null>;
